/**
 * Configuration for Footer Action Buttons
 */

import Radio from "backbone.radio";

const channel = Radio.channel("global");

const config = [
  {
    roles: ["ROLE_ALTEGRA_STAFF"],
    action: "debug",
    eventName: "debug",
    title: "Click to view the most recent debugging information",
    icon: null,
    label: "Debug",
    className: "btn btn-sm btn-link",
    datasource: "#",
    attributes: {
      "data-toggle": "modal",
      "data-target": "#debug-panel",
      "data-event-category": "View Debug",
      "data-event-action": "Open",
    },
  },
  {
    displayFn() {
      return channel.request("user:has-custom-roles");
    },
    action: "remove-custom-roles",
    eventName: "user:remove-custom-roles",
    title: "Click to remove your custom roles",
    icon: null,
    label: "Remove Custom Roles",
    className: "btn btn-sm btn-link",
    datasource: "#",
    attributes: {
      "data-event-category": "Remove Custom Roles",
      "data-event-action": "Click",
    },
  },
];

export { config as default };
